module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 31\"><defs><style> .__2OaaLkY__cls-1 { fill: #7aa097; stroke: #fff; stroke-width: 1px; fill-rule: evenodd; } </style></defs><path id=\"recruit.svg\" class=\"__2OaaLkY__cls-1 \" d=\"M101,2015h24v30H101v-30Zm7,20h10m-10-12h10m-10,6h10\" transform=\"translate(-100.5 -2014.5)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ../node_modules/svg-inline-loader?classPrefix!./img/common/recruit.svg
// module id = 17
// module chunks = 0